import { CircularProgress, Paper, Stack, Typography } from "@mui/material"
import Admin from "api/Admin"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import SimpleTable from "v2/SimpleTable"


const columns = [
    {
        label: "Type",
        name: "type"
    },
    {
        label: "principal",
        name: "principal"
    },
    {
        label: "Start Date",
        name: "start_date"
    },
    {
        label: "End Date",
        name: "end_date"
    },
    {
        label: "Duration Day(s)",
        name: "duration_days"
    },
    {
        label: "Interest",
        name: "calculated_interest"
    },

]

const staCol = [
    {
        label: "Property",
        name: "label"
    },
    {
        label: "Details",
        name: "details"
    }
]

const interests = [
    {
        label: "Interest Rate (%)",
        name: "interest_rate",
        suffix: " %"
    },
    // {
    //     label: "Disbursement Interest",
    //     name: "total_disbursement_interest",
    //     prefix: "₹ "
    // },
    // {
    //     label: "Repayment Interest",
    //     name: "total_repayment_interest",
    //     prefix: "₹ "
    // },
    {
        label: "Total Interest",
        name: "total",
        prefix: "₹ "
    }
]



export default function Interest() {

    const [data, setData] = useState(null)
    const { id } = useParams()

    const getData = async () => {
        try {
            const res = await Admin.Case.get_interest({ case_id: id })
            setData(res.data)
        } catch (error) {
            console.log(error.message)
        }
    }

    useEffect(() => {
        getData()
    }, [])


    if (!data) {
        return <Paper elevation={3}>
            <Stack direction={"row"} gap={1} justifyContent={"center"} textAlign={"center"} p={4}><CircularProgress size={24} />Loading...</Stack>
        </Paper>
    }


    const rows = data.interest_details.map(d => {
        let principal = "₹ " + d.principal
        let calculated_interest = "₹ " + d.calculated_interest

        return { ...d, principal, calculated_interest }
    })
    const interestRows = interests.map(d => {
        let details =  data[d.name] 
        if (d.name == "total") {
            details = data.total_disbursement_interest + data.total_repayment_interest
        }
        details = (d.prefix || '') + details + (d.suffix || '')
        return { ...d, details }
    })

    return (
        <Paper elevation={3}>
            <Typography color={'primary'} padding={2} flex={1} variant='h5'>Interest Details</Typography>
            <SimpleTable columns={staCol} data={interestRows} />
            <Typography padding={2} flex={1} variant='h5'>Total Interest</Typography>
            <SimpleTable columns={columns} data={rows} />
        </Paper>
    )
}
